import React from "react";
import { FaReact, FaCss3Alt, FaHtml5, FaJsSquare, FaCode, FaPaintBrush, FaSearch } from "react-icons/fa"; // Icons for skills

const ServicesSkillsSection = () => {
    return (
        <section id="services" className="bg-gray-800 text-white py-16 px-6 md:px-12 lg:px-20">
            <div className="max-w-7xl mx-auto">

                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                    My Services & Skills
                </h2>

                <div className="cursor-default grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
                    <div className="bg-gray-900 p-6 rounded-lg shadow-lg text-center transition-transform transform hover:-translate-y-2">
                        <FaCode className="text-teal-400 text-4xl mb-4 mx-auto" />
                        <h3 className="text-xl font-semibold mb-4">Web Development</h3>
                        <p className="text-gray-400 mb-4">
                            I build responsive and interactive websites using the latest web technologies.
                        </p>
                        <a href="#contact" className="text-teal-400 hover:underline">
                            Get in Touch
                        </a>
                    </div>

                    <div className="bg-gray-900 p-6 rounded-lg shadow-lg text-center transition-transform transform hover:-translate-y-2">
                        <FaPaintBrush className="text-teal-400 text-4xl mb-4 mx-auto" />
                        <h3 className="text-xl font-semibold mb-4">UI/UX Design</h3>
                        <p className="text-gray-400 mb-4">
                            Creating user-friendly and aesthetically pleasing designs with a focus on experience.
                        </p>
                        <a href="#contact" className="text-teal-400 hover:underline">
                            Get in Touch
                        </a>
                    </div>

                    <div className="bg-gray-900 p-6 rounded-lg shadow-lg text-center transition-transform transform hover:-translate-y-2">
                        <FaSearch className="text-teal-400 text-4xl mb-4 mx-auto" />
                        <h3 className="text-xl font-semibold mb-4">SEO Optimization</h3>
                        <p className="text-gray-400 mb-4">
                            Boost your website's ranking on search engines with optimized SEO strategies.
                        </p>
                        <a href="#contact" className="text-teal-400 hover:underline">
                            Get in Touch
                        </a>
                    </div>
                </div>


                <div>
                    <h3 className="text-2xl md:text-3xl font-semibold text-center mb-8">Skills</h3>
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-8">

                        <div className="flex flex-col items-center">
                            <div className="bg-gray-900 p-4 rounded-full mb-4 shadow-lg shadow-gray-900">
                                <FaReact className="text-4xl text-teal-400" />
                            </div>
                            <p className="text-xl font-medium">React</p>
                        </div>

                        <div className="flex flex-col items-center">
                            <div className="bg-gray-900 p-4 rounded-full mb-4 shadow-lg shadow-gray-900">
                                <FaCss3Alt className="text-4xl text-teal-400" />
                            </div>
                            <p className="text-xl font-medium">CSS</p>
                        </div>

                        <div className="flex flex-col items-center">
                            <div className="bg-gray-900 p-4 rounded-full mb-4 shadow-lg shadow-gray-900">
                                <FaHtml5 className="text-4xl text-teal-400" />
                            </div>
                            <p className="text-xl font-medium">HTML</p>
                        </div>

                        <div className="flex flex-col items-center">
                            <div className="bg-gray-900 p-4 rounded-full mb-4 shadow-lg shadow-gray-900">
                                <FaJsSquare className="text-4xl text-teal-400" />
                            </div>
                            <p className="text-xl font-medium">JavaScript</p>
                        </div>
                    </div>
                </div>


                <div className="mt-16">
                    <h4 className="text-2xl font-semibold text-center mb-8">My Skill Proficiency</h4>
                    <div className="space-y-6">
                        {/* Skill 1 */}
                        <div>
                            <p className="text-xl mb-2">HTML</p>
                            <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden">
                                <div
                                    className="bg-teal-400 h-2 rounded-full animate-progress"
                                    style={{ animationDelay: "0.2s", width: "97%" }}
                                ></div>
                            </div>
                        </div>
                        {/* Skill 2 */}
                        <div>
                            <p className="text-xl mb-2">CSS</p>
                            <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden">
                                <div
                                    className="bg-teal-400 h-2 rounded-full animate-progress"
                                    style={{ animationDelay: "0.4s", width: "91%" }}
                                ></div>
                            </div>
                        </div>
                        {/* Skill 3 */}
                        <div>
                            <p className="text-xl mb-2">JavaScript</p>
                            <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden">
                                <div
                                    className="bg-teal-400 h-2 rounded-full animate-progress"
                                    style={{ animationDelay: "0.6s", width: "85%" }}
                                ></div>
                            </div>
                        </div>
                        {/* Skill 4 */}
                        <div>
                            <p className="text-xl mb-2">React</p>
                            <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden">
                                <div
                                    className="bg-teal-400 h-2 rounded-full animate-progress"
                                    style={{ animationDelay: "0.8s", width: "95%" }}
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </section>
    );
};

export default ServicesSkillsSection;
